<figure appMapLegend class="legend-container" id="fix-legend" aria-label="Landline legend">
  <div class="legend-scale" aria-hidden="true"></div>
  <div class="legend-labels" role="list">
    @for (value of legend.values; track value.label) {
      <span role="listitem">{{ value.label | translate }}</span>
    }
  </div>
</figure>